import { render, staticRenderFns } from "./priceSearch.vue?vue&type=template&id=4551127e&scoped=true&"
import script from "./priceSearch.vue?vue&type=script&lang=js&"
export * from "./priceSearch.vue?vue&type=script&lang=js&"
import style0 from "./priceSearch.vue?vue&type=style&index=0&id=4551127e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4551127e",
  null
  
)

export default component.exports